











import { defineComponent } from '@nuxtjs/composition-api';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';

export default defineComponent({
    props:{
        areaCta: {
            type: String, required: true
        },
        manageScroll:{
            type: Function,
            default:()=>{}
        }
    },
    setup(props){
        const ctasObj = getAsJSON(props.areaCta);
        return {
            ctasObj
        }
    },
    data(){
        return {
            editorialStickyBtn: null
        }
    },
    mounted() {
        try{
            this.editorialStickyBtn = this.ctasObj.children[0].children[0].children.find(btn=>btn.cssClasses.includes('pdp-bottom')).DOMContent.children[0];
            
        }catch(e){
            console.error(e)
            /** no sticky b tn choosen from area_cta */
        }
    }
})
